import useSWR from 'swr'

const useRandomJoke = () => {
  const { data, error, mutate } = useSWR('/')

  return {
    data: data?.joke,
    loading: !data?.joke && !error,
    error: error,
    mutate,
  }
}

export default useRandomJoke
